export enum Role {
    SysAdmin = 'SysAdmin',
}
